<template>
  <div class="">
    <div v-for="item in newsList" :key="item.id" class="text-left py-8">
      <p class="text-base">{{ item.title }}</p>
      <p class="text-sm text-gray-500" v-html="item.content"></p>
      <p class="flex-center mt-10">
        <button v-if="item.tag == 'delaccount'" class="close-btn" @click="closeAccount()">{{ $t('确认注销') }}</button>
      </p>
    </div>
    <el-pagination background layout="prev, pager, next" :total="newsListTotal" :page-size="8"
      @current-change="handleCurrentChange" :hide-on-single-page="true"></el-pagination>
  </div>
</template>
<script>
import { ref, watch, onMounted,computed } from "@vue/composition-api";

export default {
  setup(props, ctx) {
    const current_tag = ref();
    const newsList = ref();
    const newsListTotal = ref();
    const getNewsList = async (...args) => {
      const res = await ctx.root.$callapi("news/getNewsList", {
        page: args[0],
        size: 8,
        tag: args[1],
      });

      newsList.value = res.data.items;
      newsListTotal.value = res.data.total;
    };
    watch(
      () => ctx.root.$route.query.tag,
      () => {
        current_tag.value = ctx.root.$route.query.tag;
        getNewsList(1, current_tag.value);
      }
    );
    //下一页
    const handleCurrentChange = (val) => {
      getNewsList(val, current_tag.value);
    };
    const delHtmlTag = (str) => {
      return str.replace(/<[^>]+>/g, "");
    };
    onMounted(() => {
      getNewsList(1, ctx.root.$route.query.tag);
    });
    const closeAccount = async () => {
      const r = await ctx.root.$query(ctx.root.$t("账号注销后无法恢复, 确认注销吗？"))
      if (r) {
        const res = await ctx.root.$callapi("user/closeAccount")
        if (res && res.data) {
          if (res.data.closed) {
            ctx.root.$doing()
						await ctx.root.$callapi("user/logout", {})
						ctx.root.$done()
            await ctx.root.$toast(ctx.root.$t('注销成功'), 'success') 
            ctx.root.$goto("/");
            window.location.reload()
          }
        }
      }
    }
    return {
      current_tag,
      newsList,
      newsListTotal,
      handleCurrentChange,
      delHtmlTag,
      closeAccount,
    };
  },
};
</script>
<style scoped lang="scss">
.close-btn {
  @apply w-9.4rem h-2.3rem text-1rem border-0 bg-red-500 text-white;
}
</style>